import { Injectable, Component, ComponentFactoryResolver } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { map, retry, catchError } from 'rxjs/operators';
import { NotifierService } from 'angular-notifier';
import { NotifierModule } from 'angular-notifier';
import { DatePipe } from '@angular/common';
import { EnvService } from './service/system/env-service';
import * as fileSaver from 'file-saver';
import { MsAdalAngular6Service } from 'microsoft-adal-angular6';
import { AuthenticationService } from './service/system/authentication.service';

@Injectable({
  providedIn: 'root'
})

export class ApiService {

  private readonly notifier: NotifierService;
  onLanguageChanged = new BehaviorSubject({ value: 'en_us', label: 'English' });
  onChannelChanged = new BehaviorSubject({ value: 'webchat', label: 'Webchat' });

  constructor(private http: HttpClient, notifierService: NotifierService, private datePipe: DatePipe,
    private env: EnvService,) {
    this.notifier = notifierService;
  }

  changeChannel(channel) {
    this.onChannelChanged.next(channel);
  }

  changeLanguage(language) {
    this.onLanguageChanged.next(language);
  }

  // Get conversation list
  public getConversationList(from: Date, to: Date, language: string, channel: string, pageNo: number, limit: number, searchText: string, searchType: string, sortByCol: string, sortByType: string, token: string): Observable<any> {
    // return this.http.get<any>(environment.apiUrl + 'conversations?' + 'from=' + from + '&to=' + to + '&language=' + language + '&channel=' + channel + '&skill_id&rating&review_status' + '&page=' + pageNo + '&limit=' + limit + '&search=' + searchText + '&searchType=' + searchType + '&sort=' + sortByCol + '&sortBy=' + sortByType)
    // const headers = {'token': btoa(token) }
    // var url = `from=${}&to=${}&language=${language}&ChannelName=${channel}&IsAscending=false&limit=${limit}`;
    var body = {
      from: this.datePipe.transform(from, "yyyy-MM-dd"),
      to: this.datePipe.transform(to, "yyyy-MM-dd"),
      language: language,
      channel_name: channel,
      is_ascending: false,
      limit: limit,
      token: token ? token : ""
    }
    return this.http.post<any>(this.env.baseUrl + 'review_tool/conversations', body)
      .pipe(
        map(response => {
          return response;
        }),
        retry(1),
        catchError(this.handleError)
      )
  }

  // Get full conversation list by ID
  public getFullConversationList(conversationId: string): Observable<any> {
    return this.http.post<any>(this.env.baseUrl + `review_tool/conversations/${conversationId}/transcript`, {})
      .pipe(
        map(response => {
          var msgArray = [];
          var id = 1;
          let conversations = response["data"].transcript;
          conversations.forEach((convo, index) => {
            msgArray.push({
              id: id,
              text: convo.request.text,
              type: convo.request.message_type,
              comment_count: convo.request.review_comment ? 1 : 0,
              timestamp: convo.request.timestamp,
              quick_reply: convo.request.quick_reply,
              document_id: convo.request.document_id,
              prediction: convo.request.prediction,
              skill_concept: convo.request.skill_concept,
              message_type: convo.request.type,
              skill_id: convo.request.skill_id,
              review_comment: convo.request.review_comment,
              training_phrase: convo.request.training_phrase
            });
            id++;

            convo.responses.forEach((res, ind) => {
              msgArray.push({
                id: id,
                text: res.text,
                type: res.message_type,
                comment_count: res.review_comment ? 1 : 0,
                timestamp: res.timestamp,
                quick_replies: res.quick_replies,
                search_documents: res.search_documents,
                document_id: res.document_id,
                review_comment: res.review_comment,
                training_phrase: res.training_phrase ? res.training_phrase : "",
                skill_id: res.skill_id ? res.skill_id : "",
              });
              id++;
            })
          });
          var newResponse = {
            data: msgArray,
            status: response.status,
            status_details: response.status_details,
          }
          return newResponse;
        }),
        retry(1),
        catchError(this.handleError)
      )
  }

  // Post feedback form
  public addFeedbackConversation(conversationId: string, documentId: string, skill: string, trainingPhrase: string, comment: string, type: string): Observable<any> {
    // return this.http.post<any>(environment.apiUrl + 'save_io_comments', {})
    var body = {};
    if (type === "outgoing") {
      body = {
        review_comment: comment,
        type: type
      }
    } else {
      body = {
        skill_id: skill,
        training_phrase: trainingPhrase,
        review_comment: comment,
        type: type
      }
    }
    return this.http.post<any>(this.env.baseUrl + `review_tool/conversations/${conversationId}/transcript/${documentId}/review/save`, body)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  // Get intents list
  public getIntentList(): Observable<any> {
    return this.http.get<any>(this.env.baseUrl + 'review_tool/skills')
      .pipe(
        map(response => {
          var skills = [];
          response.data.forEach((item, index) => {
            skills.push({
              id: index + 1,
              intent: item
            })
          })
          var res = {
            data: skills,
            status: 200,
            status_details: 'Success'
          }
          return res;
        }),
        retry(1),
        catchError(this.handleError)
      )
  }

  // Sync Consmos DB
  // Deprecated
  public syncCosmosData(): Observable<any> {
    return this.http.get<any>(this.env.baseUrl + 'review_tool/import_conversations')
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  // Completed feedback status
  public completeFeedBackStatus(conversationId): Observable<any> {
    var body = {
      review_status: 'Completed',
      review_comment: 'Done'
    };
    return this.http.post<any>(this.env.baseUrl + `review_tool/conversations/${conversationId}/review/save`, body)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  // Get the unknown service list
  public getUnknownRequestList(from: Date, to: Date, language: string, channel: string, pageNo: number, limit: number, searchText: string, searchType: string, sortByCol: string, sortByType: string, token: string): Observable<any> {
    // return this.http.get<any>(environment.apiUrl + 'get_unknown_requests?' + 'page=' + pageNo + '&limit=' + limit + '&search=' + searchText + '&searchType=' + searchType + '&sort=' + sortByCol + '&sortBy=' + sortByType)
    // var url = "";
    // if (token) {
    //   url = `requests/unknown_requests?from=${this.datePipe.transform(from, "yyyy-MM-dd")}&to=${this.datePipe.transform(to, "yyyy-MM-dd")}&language=${language}&ChannelName=${channel}&IsAscending=false&limit=${limit}&token=${token}`;
    // } else {
    //   url = `requests/unknown_requests?from=${this.datePipe.transform(from, "yyyy-MM-dd")}&to=${this.datePipe.transform(to, "yyyy-MM-dd")}&language=${language}&ChannelName=${channel}&IsAscending=false&limit=${limit}`;
    // }
    var body = {
      from: this.datePipe.transform(from, "yyyy-MM-dd"),
      to: this.datePipe.transform(to, "yyyy-MM-dd"),
      language: language,
      channel_name: channel,
      is_ascending: false,
      limit: limit,
      token: token ? token : ""
    }
    return this.http.post<any>(this.env.baseUrl + 'review_tool/requests/unknown_requests', body)
      .pipe(
        map(response => {
          var data = [];
          response.data.forEach((item, index) => {
            data.push({
              id: index + 1,
              Timestamp: item.timestamp,
              Text: item.text,
              comment: (!item.review_comment || item.review_comment == '') ? null : item.review_comment,
              document_id: item.document_id,
              conversation_id: item.conversation_id,
              SkillLabel: (!item.skill_id || item.skill_id == '') ? null : item.skill_id,
              saved: (item.skill_id || item.review_comment) ? true : false,
              updated: false
            });
          })
          var res = {
            data: data,
            status: 200,
            status_details: 'Success',
            has_next: response["has_next"],
            token: response["token"]
          }
          return res;
        }),
        retry(1),
        catchError(this.handleError)
      )
  }

  // delete Unknown request by Id
  // Deprecated
  public deleteUnknownRequestItem(body: any): Observable<any> {
    return this.http.delete<any>(this.env.baseUrl + 'review_tool/delete_unknown_requests?request_id=' + body.request_id)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  // update Unknown request status
  public updateUnknownRequestItem(conversationId: string, documentId: string, trainingPhrase: string, skill: string, comment: string): Observable<any> {
    // return this.http.post<any>(environment.apiUrl + 'update_unknown_requests', body)
    var body = {
      skill_id: skill,
      training_phrase: trainingPhrase,
      review_comment: comment
    }
    return this.http.post<any>(this.env.baseUrl + `review_tool/requests/unknown_requests/${conversationId}/${documentId}/review/save`, body)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // import Unknown request status
  // Deprecated
  public syncUnknownRequestList(): Observable<any> {
    return this.http.get<any>(this.env.baseUrl + 'import_unknown_requests')
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  public downloadConversationFile(from: string, to: string, channel: string, language: string) {
    var body = {
      from: from,
      to: to,
      channel_name: channel,
      language: language
    }
    this.http.post(this.env.baseUrl + `review_tool/conversations/export`, body, { responseType: 'arraybuffer' }).subscribe(data => {
      var file = new Blob([data], { type: 'application/json' });
      // var fileURL = URL.createObjectURL(file);
      // window.open(fileURL);
      fileSaver.saveAs(file, `conversations-(${from} - ${to}).json`);
    });
  }

  public downloadUnknowRequestsFile(from: string, to: string, channel: string, language: string) {
    var body = {
      from: from,
      to: to,
      channel_name: channel,
      language: language
    }
    this.http.post(this.env.baseUrl + `review_tool/requests/unknown_requests/export`, body, { responseType: 'arraybuffer' }).subscribe(data => {
      var file = new Blob([data], { type: 'application/json' });
      fileSaver.saveAs(file, `unknown-requests-(${from} - ${to}).json`);
    });
  }

  // Deprecated
  public resolveApplicationsDetailse(appIds: string[]) {
    var body = {
      active_directory_ids: appIds
    }
    return this.http.post<any>(this.env.baseUrl + `insights/v1/applications/tenants`, body)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  handleError(error: Response | any) {
    document.getElementById("loaderSpinner").style.display = 'none';
    document.getElementById("alertMessage").style.display = "block";
    setTimeout(() => {
      document.getElementById("alertMessage").style.display = "none";
    }, 3000)
    return Observable.throw(error);
  }
}
